export const Role = {
    LawFirm: 'LAW_FIRM_USER.PAGE',
    LMSUser: 'LMS_USER.PAGE',
  };